import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import './HomePage.css';
import HeaderHomePage from './HeaderHomePage';

const HomePage = () => {
    const handleSignupClick = () => {
        // Redirect to app subdomain for signup
        window.location.href = 'https://app.prontoservices360.com/authentication/signup';
    };

    return (
        <div className="m-2">
            <HeaderHomePage />
            {/* Introduction Section */}
            <div className="container">
                <Row className="about-main">
                    <Col lg={8} md={8} sm={12} className="text-center">
                        <div className="header-logo mt-4">
                            <img
                                src="/logo.png"
                                className="logo-1"
                                alt="Pronto Services 360 Logo"
                            />
                        </div>
                        <span className="leading-normal px-2 px-3 py rounded-pill tx-13 bold">
                            Efficient Management with Intelligent AI Solutions
                        </span>
                        <h1 className="mb-3 font-weight-bolder tx-46">
                            Your <span className="invoice-platform tx-38 text-black-50 px-1 py-1">CRM - Estimate - Invoice</span> Platform
                        </h1>
                        <p className="leading-normal tx-16 mt-3">
                            Pronto Services 360 is an all-in-one platform with integrated CRM, helping service businesses streamline operations, manage customer relationships, automate tasks, and drive growth effortlessly.
                        </p>
                        <div
                            aria-label="Action buttons"
                            className="btn-group w-100"
                            role="group"
                        >
                            <Button
                                variant=""
                                className="btn btn-outline-pronto btn-action"
                                type="button"
                                onClick={handleSignupClick}
                            >
                                Start <b>FREE TRIAL</b> now
                            </Button>
                        </div>
                        <small>No credit card required</small>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default HomePage;
